import html from './starRating.html';

class StarRatingCtrl {
  $onInit() {
    this.stars = new Array(this.maxRate).fill(true).map((_, index) => index + 1);
  }
}

export default {
  bindings: {
    maxRate: '<',
    onRate: '&',
    rating: '<',
  },
  controller: StarRatingCtrl,
  controllerAs: 'ctrl',
  templateUrl: html,
};
